module.exports = __webpack_public_path__ + "img/flower_leaf_17.5b9f3431.png";